module.exports = __webpack_public_path__ + "static/f8-1-c593ddbe4ceb3b6daf452fcdda9b7bb6.jpeg";